"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var condition_reader_1 = require("./condition-reader");
var interpreter_utils_1 = require("../../../interpreter-utils");
var lodash_1 = require("lodash");
var condition_utils_1 = require("./condition-utils");
var ConditionFieldReader = /** @class */ (function (_super) {
    __extends(ConditionFieldReader, _super);
    function ConditionFieldReader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ConditionFieldReader.getEntityFieldValue = function (value, parameter) {
        if (value['hasProperty'] && value['getProperty'] && value['hasProperty'](parameter)) {
            return value['getProperty'](parameter).value;
        }
        else if (lodash_1.isArray(value)) {
            return value[parameter];
        }
        else {
            return interpreter_utils_1.getOptionalProperty(value, parameter, undefined);
        }
    };
    ConditionFieldReader.prototype.internalRead = function (key, value) {
        var _this = this;
        var predicate;
        if (condition_utils_1.isPlainConditionValue(value)) {
            predicate = lodash_1.eq;
        }
        else if (lodash_1.isNil(value)) {
            predicate = function (item, _) { return lodash_1.isNil(item); };
        }
        else {
            predicate = value;
        }
        return function (context) {
            if (lodash_1.isString(value) && value.startsWith('actions')) {
                var methodName = _this.parseActionMethodName(value);
                var actions = interpreter_utils_1.getRequiredProperty(context, 'actions');
                var methodValue_1 = actions[methodName]();
                predicate = function (item) { return lodash_1.eq(item, methodValue_1); };
            }
            if (key.startsWith('actions')) {
                throw new Error('Not Supported');
            }
            else if (key.startsWith('entity') && lodash_1.isString(value) && value.startsWith('entity')) {
                return predicate(condition_utils_1.getEntityValue(context, key), condition_utils_1.getEntityValue(context, value));
            }
            else if (key.startsWith('entity')) {
                if (lodash_1.isString(value) && !lodash_1.isNaN(Date.parse(value))) {
                    return predicate(condition_utils_1.getEntityValue(context, key), Date.parse(value));
                }
                return predicate(condition_utils_1.getEntityValue(context, key), condition_utils_1.isPlainConditionValue(value) ? value : context);
            }
            else if (key.startsWith('queryParams')) {
                return predicate(condition_utils_1.getQueryParamValue(context, key), condition_utils_1.isPlainConditionValue(value) ? value : context);
            }
            else if (key.startsWith('item')) {
                return predicate(condition_utils_1.getItemValue(context, key), condition_utils_1.isPlainConditionValue(value) ? value : context);
            }
            else {
                return predicate(interpreter_utils_1.getRequiredProperty(context, key), condition_utils_1.isPlainConditionValue(value) ? value : context);
            }
        };
    };
    ConditionFieldReader.prototype.isSupported = function (key) {
        return !key.startsWith('$');
    };
    ConditionFieldReader.prototype.parseEntityField = function (obj, path) {
        var _a = /^([^.]+)\.?(.*)$/g.exec(path), parameter = _a[1], postfix = _a[2];
        var currValue = ConditionFieldReader.getEntityFieldValue(obj, parameter);
        if (!currValue) {
            return undefined;
        }
        else if (postfix !== '') {
            return this.parseEntityField(currValue, postfix);
        }
        else {
            return currValue;
        }
    };
    ConditionFieldReader.prototype.parseActionMethodName = function (value) {
        return value.slice(value.indexOf('.') + 1, value.indexOf('('));
    };
    return ConditionFieldReader;
}(condition_reader_1.ConditionReader));
exports.ConditionFieldReader = ConditionFieldReader;
//# sourceMappingURL=condition-field-reader.js.map